/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiAlbumsIdMutationResponse, DeleteApiAlbumsIdPathParams, DeleteApiAlbumsId400, DeleteApiAlbumsId401, DeleteApiAlbumsId403, DeleteApiAlbumsId404, DeleteApiAlbumsId500 } from "../../types/DeleteApiAlbumsId.ts";
import { deleteApiAlbumsIdMutationResponseSchema } from "../../zod/AlbumSchemas/deleteApiAlbumsIdSchema.ts";

function getDeleteApiAlbumsIdUrl({ id }: { id: DeleteApiAlbumsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/albums/${id}` as const }  
  return res
}

/**
 * @summary Метод удаления альбома.
 * {@link /api/albums/:Id}
 */
export async function deleteApiAlbumsId({ id }: { id: DeleteApiAlbumsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiAlbumsIdMutationResponse, ResponseErrorConfig<DeleteApiAlbumsId400 | DeleteApiAlbumsId401 | DeleteApiAlbumsId403 | DeleteApiAlbumsId404 | DeleteApiAlbumsId500>, unknown>({ method : "DELETE", url : getDeleteApiAlbumsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiAlbumsIdMutationResponseSchema.parse(res.data)
}